import * as React from 'react';
import { SVGProps } from 'react';

const IconMaxHeightSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12.444 20H20v2H4v-2h7.556L8 16h3V8H8l3.556-4H4V2h16v2h-7.556L16 8h-3v8h3l-3.556 4z" />
  </svg>
);
export default IconMaxHeightSizeM;
